import { render, staticRenderFns } from "./StatsUnitsPerEmployee.vue?vue&type=template&id=0fe51d45&"
import script from "./StatsUnitsPerEmployee.vue?vue&type=script&lang=js&"
export * from "./StatsUnitsPerEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe51d45')) {
      api.createRecord('0fe51d45', component.options)
    } else {
      api.reload('0fe51d45', component.options)
    }
    module.hot.accept("./StatsUnitsPerEmployee.vue?vue&type=template&id=0fe51d45&", function () {
      api.rerender('0fe51d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/StatsUnitsPerEmployee.vue"
export default component.exports